<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="1000px"
              scrollable
    >
        <v-card>
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">
                  My Properties - Add Me - Landlord
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-4">
              <v-stepper v-model="step" vertical :elevation="0" class="rpd-stepper pb-0" style="margin: auto; max-width: 1000px;">
                <v-stepper-step editable step="1" :complete="step > 1" class="pb-4 pt-4">
                  Select Contact Type <strong v-if="contactTypeText">{{ contactTypeText }}</strong> <br/>
                  <!-- small text -->
                  <!-- <small v-if="step == 1">Select whether you would like to be added as a Tenant or Tenants Agent</small> -->
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-btn depressed color="primary" @click="() => selectContactType('landlord')">Landlord contact</v-btn>
                  <v-btn depressed class="ml-2" color="primary" @click="() => selectContactType('landlord_agent')">Landlords agent</v-btn>
                </v-stepper-content>
                <v-stepper-step :editable="editable" step="2" :complete="step > 2" class="pt-4">
                  Select schemes to be added (optional) <strong v-if="selectedSchemes.length">({{ selectedSchemes.length }})</strong>
                </v-stepper-step>
                <v-stepper-content step="2">
                  <v-row class="mt-0">
                    <v-col>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn height="40" v-on="on" class="elevation-0 mr-4" color="primary" outlined @click="newScheme">
                            <span class="mr-2">New Scheme</span>
                            <v-icon size="20">mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>If the scheme does not appear in the list below, click here to add it to RPD</span>
                      </v-tooltip>
                    </v-col>
                    <v-col>
                      <v-autocomplete
                        v-model="schemesLandlordFilter"
                        :loading="schemeLandlords.loading"
                        :items="schemeLandlords.items"
                        :search-input.sync="schemeLandlords.search"
                        cache-items
                        dense
                        outlined
                        flat
                        hide-no-data
                        clearable
                        item-text="name"
                        item-value="id"
                        label="Landlord"
                        @change="getSchemes"
                      ></v-autocomplete>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="schemesSearch"
                        append-icon="mdi-table-search"
                        label="Search"
                        single-line
                        outlined
                        dense
                        hide-details
                        @input="getSchemes"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-data-table
                                style="border: 1px solid #e0e0e0; border-radius: 4px;"
                                :headers="schemeHeaders"
                                :items="schemes.items"
                                :options.sync="schemes.pagination"
                                :loading="schemes.loading"
                                :server-items-length="schemes.totalRecords"
                                :items-per-page.sync="schemes.itemsPerPage"
                                :sort-by.sync="schemes.sortBy"
                                :sort-desc.sync="schemes.sortDesc"
                                :page.sync="schemes.page"
                  >
                    <template v-slot:body="{ items }">
                      <tbody v-if="items.length">
                        <tr v-for="item in items" :key="item.id">
                          <td><a @click="() => showEditScheme(item.id)">{{ item.name }}</a></td>
                          <td>{{ item.address.data.full_address }}</td>
                          <td class="text-center">{{ item.properties_count }}</td>
                          <td>
                            <v-btn v-if="checkSchemeSelected(item)" style="width:120px" height="40" outlined color="primary" @click="() => selectScheme(item)">
                              <v-icon class="mr-1">mdi-plus</v-icon>
                              <span>Add</span>
                            </v-btn>
                            <v-btn v-else height="40" style="width:120px" outlined color="red" @click="() => unSelectScheme(item)">
                              <v-icon class="mr-1">mdi-close</v-icon>
                              <span>Remove</span>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="4" class="text-center">No schemes found</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
        <!--          selected schemes list-->
                  <!-- <v-row v-if="selectedSchemes.length">
                    <v-col>
                      <h3>Selected Schemes</h3>
                      <v-list>
                        <v-list-item v-for="scheme in selectedSchemes" :key="scheme.id">
                          <v-list-item-content>
                            <v-list-item-title>{{ scheme.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{ scheme.address.data.full_address }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon @click="() => unSelectScheme(scheme)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row> -->
                  <v-btn class="mt-6" depressed color="primary" @click="step = 3">Continue</v-btn>
                </v-stepper-content>

                <v-stepper-step step="3" :editable="editable" class="pt-4">
                  Select standalone properties to be added (optional) <strong v-if="selectedProperties.length">({{ selectedProperties.length }})</strong>
                  <small  v-if="step == 3">A standalone property is simply a property that is not included in a scheme. For example; a shop on the high street or a supermarket.</small>
                </v-stepper-step>
                <v-stepper-content step="3">
                  <v-row class="mt-0">
                    <v-col>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: onMenu }">
                          <v-menu offset-y >
                            <template v-slot:activator="{ on: onTooltip }">
                              <v-btn height="40" class="elevation-0 mr-4" color="primary" outlined v-on="{ ...onMenu, ...onTooltip }">
                                <span class="mr-2">New Property</span>
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="addProperty">
                                <v-list-item-title>New Standalone Property</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="addProperty('scheme')">
                                <v-list-item-title>New Scheme Property</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </template>
                        <span>If the property does not appear in the list below, click here to add it to RPD</span>
                      </v-tooltip>
                    </v-col>
                    <v-col>
                      <v-autocomplete
                        v-model="propertiesLandlordFilter"
                        :loading="propertyLandlords.loading"
                        :items="propertyLandlords.items"
                        :search-input.sync="propertyLandlords.search"
                        cache-items
                        flat
                        outlined
                        dense
                        hide-no-data
                        clearable
                        item-text="name"
                        item-value="id"
                        label="Landlord"
                        @change="getProperties"
                      ></v-autocomplete>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="propertiesSearch"
                        append-icon="mdi-table-search"
                        label="Search"
                        outlined
                        dense
                        single-line
                        hide-details
                        @input="getProperties"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-data-table style="border: 1px solid #e0e0e0; border-radius: 4px;"
                                :headers="propertyHeaders"
                                :items="properties.items"
                                :options.sync="properties.pagination"
                                :loading="properties.loading"
                                :server-items-length="properties.totalRecords"
                                :items-per-page.sync="properties.itemsPerPage"
                                :sort-by.sync="properties.sortBy"
                                :sort-desc.sync="properties.sortDesc"
                                :page.sync="properties.page"
                  >
                    <template v-slot:body="{ items }">
                      <tbody v-if="items.length">
                      <tr v-for="item in items" :key="item.id">
                        <td><a @click="() => showEditProperty(item.id)">{{ item.building_num }}</a></td>
                        <td>{{ item.tenant.data.name }}</td>
                        <td>{{ item.address.data.full_address }}</td>
                        <td>
                          <v-btn v-if="selectedProperties.some(p => p.id === item.id)" height="40" style="width:120px" outlined color="red" @click="() => unSelectProperty(item)">
                            <v-icon class="mr-1">mdi-close</v-icon>
                            <span>Remove</span>
                          </v-btn>
                          <v-btn v-else height="40" style="width:120px" outlined color="primary" @click="() => selectProperty(item)">
                            <v-icon class="mr-1">mdi-plus</v-icon>
                            <span>Add</span>
                          </v-btn>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="4" class="text-center">No properties found</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
        <!--          selected properties list-->
                  <!-- <v-row v-if="selectedProperties.length">
                    <v-col>
                      <h3>Selected Properties</h3>
                      <v-list>
                        <v-list-item v-for="property in selectedProperties" :key="property.id">
                          <v-list-item-content>
                            <v-list-item-title>{{ property.building_num? property.building_num + ',' : '' }} {{ property.tenant.data.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{ property.address.data.full_address }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon @click="() => unSelectProperty(property)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                  <h2>What is Standalone Property?</h2>
                  <p>
                    A standalone property is simply a property that is not included in a scheme. For example; a shop on the high street or a supermarket.
                  </p> -->
                  <v-btn class="mt-6" depressed :disabled="!isCanBeSubmitted" color="primary" @click="submit">Finish</v-btn>
                </v-stepper-content>
              </v-stepper>
            </v-card-text>
            <edit-property-dialog ref="editPropertyDialog"></edit-property-dialog>
            <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>
            <add-property-dialog ref="addPropertyDialog" @added="getProperties"></add-property-dialog>
            <add-scheme-property-dialog ref="addSchemePropertyDialog" @added="getProperties"></add-scheme-property-dialog>
            <add-scheme-dialog ref="addSchemeDialog" @added="getSchemes"></add-scheme-dialog>
            <!-- <select-properties-map-dialog ref="selectPropertiesMapDialog" @submitted="selectProperties"></select-properties-map-dialog> -->
            <!-- <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click="closeDialog">Cancel</v-btn>
                <v-btn depressed :loading="loading"  color="primary" @click="submit">Save</v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>
</template>
<script>

import EditPropertyDialog from "@/components/properties/editPropertyDialog";
import EditSchemeDialog from "@/components/schemes/editSchemeDialog.vue";
import SelectPropertiesMapDialog from "@/pages/myProperties/SelectPropertiesMapDialog.vue";
import AddPropertyDialog from '@/components/properties/addPropertyDialog'
import AddSchemePropertyDialog from '@/components/properties/addSchemePropertyDialog'
import AddSchemeDialog from '@/components/schemes/addSchemeDialog'

export default {
  components: {SelectPropertiesMapDialog, EditSchemeDialog, EditPropertyDialog, AddPropertyDialog, AddSchemePropertyDialog, AddSchemeDialog},
  directives: {
  },
  data: () => ({
    dialog: false,
    step: 1,
    propertiesSearch: '',
    schemesSearch: '',
    propertiesLandlordFilter: null,
    schemesLandlordFilter: null,
    // landlords: {
    //   loading: false,
    //   items: [],
    //   search: '',
    // },
    schemeLandlords: {
      loading: false,
      items: [],
      search: '',
    },
    propertyLandlords: {
      loading: false,
      items: [],
      search: '',
    },
    schemes: {
      pagination: {},
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      page: 1,
      totalRecords: 0,
      loading: false,
      items: [],
    },
    properties: {
      pagination: {},
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      page: 1,
      totalRecords: 0,
      loading: false,
      items: [],
    },
    propertyHeaders: [
      { text: 'Unit', value: 'building_num', class:'data-table__cell'},
      { text: 'Tenant', value: 'tenant.data.name', class:'data-table__cell' },
      { text: 'Address', value: 'address', class:'data-table__cell' },
      { text: '', value: 'actions', sortable: false  },
    ],
    schemeHeaders: [
      { text: 'Name', value: 'name', class:'data-table__cell' },
      { text: 'Address', value: 'address', class:'data-table__cell' },
      { text: 'Properties', value: 'properties_count', class:'data-table__cell' },
      { text: '', value: 'actions', sortable: false  },
    ],
    selectedSchemes: [],
    selectedProperties: [],

    contactType: null,
  }),
  watch: {
    'schemeLandlords.search'() {
      this.getLandlords('scheme')
    },
    'propertyLandlords.search'() {
      this.getLandlords('property')
    },
    'schemesLandlordFilter'() {
      this.schemes.pagination.page = 1
    },
    'schemes.pagination': {
      handler() {
        this.getSchemes()
      },
      deep: true
    },
    'propertiesLandlordFilter'() {
      this.properties.pagination.page = 1
    },
    'properties.pagination': {
      handler() {
        this.getProperties()
      },
      deep: true
    },
  },
  computed: {
    contactTypeText() {
      switch (this.contactType) {
        case 'landlord':
          return 'Landlord contact'
        case 'landlord_agent':
          return 'Landlords agent'
        default:
          return ''
      }
    },
    isCanBeSubmitted() {
      return (this.selectedSchemes.length || this.selectedProperties.length) && this.contactType
    },
    editable() {
      if(this.contactType){
        return true
      }else{
        return false
      }
    }
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },

    clearForm() {
      this.step = 1
      this.contactType = null
      this.selectedSchemes = []
      this.selectedProperties = []
      this.schemesSearch = ''
      this.propertiesSearch = ''
      this.schemesLandlordFilter = null
      this.propertiesLandlordFilter = null
      
      
    },

    showEditProperty(id) {
      this.$refs.editStandalonePropertyDialog.showDialog(id);
    },
    showEditScheme(id) {
      this.$refs.editSchemeDialog.showDialog(id);
    },
    selectContactType(type) {
      this.contactType = type
      this.step = 2
    },
    async submit() {
      const formData = {
        contact_type: this.contactType,
        scheme_ids: this.selectedSchemes.map(s => s.id),
        property_ids: this.selectedProperties.map(p => p.id),
      };
      await this.$http.post(`/contacts/add-me`, formData).then(() => {
        this.$emit('submitted')
        this.clearForm()
        this.closeDialog()
      })
    },
    routeToAddScheme() {
      const routeData = this.$router.resolve({name: 'schemes.create'})
      window.open(routeData.href, '_blank');
    },
    routeToAddProperty() {
      const routeData = this.$router.resolve({name: 'properties.create'})
      window.open(routeData.href, '_blank');
    },
    async getSchemes() {
      this.schemes.loading = true;
      const response = await this.$http.get('/schemes', {
        params: {
          q: this.schemesSearch,
          include: 'address',
          landlord_id: this.schemesLandlordFilter,
          page: this.schemes.pagination.page,
          sort_by: this.schemes.pagination.sortBy.length ? this.schemes.pagination.sortBy[0] : null,
          desc: this.schemes.pagination.sortDesc.length ? (this.schemes.pagination.sortDesc[0] ? 1 : 0) : null,
          per_page: this.schemes.pagination.itemsPerPage,
          // hide_ids: this.selectedSchemes.map(s => s.id),
        }
      });
      this.schemes.loading = false;
      const pagination = response.data.meta.pagination
      this.schemes.totalRecords = pagination.total
      this.schemes.items = response.data.data
    },
    async getProperties() {
      this.properties.loading = true;
      const response = await this.$http.get('/properties', {
        params: {
          q: this.propertiesSearch,
          include: 'address,tenant',
          landlord_id: this.propertiesLandlordFilter,
          page: this.properties.pagination.page,
          sort_by: this.properties.pagination.sortBy.length ? this.properties.pagination.sortBy[0] : null,
          desc: this.properties.pagination.sortDesc.length ? (this.properties.pagination.sortDesc[0] ? 1 : 0) : null,
          per_page: this.properties.pagination.itemsPerPage,
          // hide_ids: this.selectedProperties.map(p => p.id),
          type: 'standalone',
        }
      });
      this.properties.loading = false;
      const pagination = response.data.meta.pagination
      this.properties.totalRecords = pagination.total
      this.properties.items = response.data.data
    },
    async getLandlords(type) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: type === 'scheme' ? this.schemeLandlords.search : this.propertyLandlords.search,
          per_page: 100,
        }
      });

      if (type === 'scheme') {
        this.schemeLandlords.items = response.data.data
      } else {
        this.propertyLandlords.items = response.data.data
      }
    },

    checkSchemeSelected(item){
      if(this.selectedSchemes.some(p => p.id === item.id)){
        return false
      }else{
        return true
      }
    },

    addProperty(type) {
      if (type === 'scheme') {
        this.$refs.addSchemePropertyDialog.openDialog();
      } else {
        this.$refs.addPropertyDialog.openDialog();
      }
    },

    newScheme() {
      this.$refs.addSchemeDialog.openDialog();
    },

    selectScheme(scheme) {
      this.selectedSchemes.push(scheme)
      // this.schemes.items = this.schemes.items.filter(s => s.id !== scheme.id)
    },
    unSelectScheme(scheme) {
      this.selectedSchemes = this.selectedSchemes.filter(s => s.id !== scheme.id)
      // this.schemes.items.push(scheme)
    },
    selectProperty(property) {
      this.selectedProperties.push(property)
      // this.properties.items = this.properties.items.filter(p => p.id !== property.id)
    },
    unSelectProperty(property) {
      this.selectedProperties = this.selectedProperties.filter(p => p.id !== property.id)
      // this.properties.items.push(property)
    },
  }
}
</script>